<template>
  <button
    aria-label="Open Wabunka AI Chat"
    type="button"
    :class="[
      'flex items-center bg-gradient-to-br from-light-fg-accent to-dark-fg-accent p-2.5 text-white shadow-xl shadow-light-fg-accent/45 transition-all duration-300 ease-out hover:scale-105 active:scale-95 motion-reduce:transition-none',
      collapsed ? 'rounded-sm' : 'rounded-full',
    ]"
    @click="$emit('click')"
  >
    <!-- アイコン -->
    <span class="flex size-7 shrink-0 items-center justify-center">
      <MessageCircle class="size-5" />
    </span>
    <!-- 2行ラベル：collapsed=true で max-width/opacity/margin が同時に transition してアイコンのみに縮小 -->
    <span
      :class="[
        'flex flex-col overflow-hidden whitespace-nowrap text-left transition-all duration-300 ease-out motion-reduce:transition-none',
        collapsed ? 'ml-0 mr-0 max-w-0 opacity-0' : 'ml-1.5 mr-1 max-w-[200px] opacity-100',
      ]"
    >
      <span class="font-Spectral text-[13px] font-medium leading-none">Wabunka AI Chat</span>
      <span class="mt-0.5 text-[10px] leading-none text-white/70">Ask about this experience</span>
    </span>
  </button>
</template>

<script setup lang="ts">
import { MessageCircle } from '@lucide/vue';

interface Props {
  collapsed: boolean;
}

defineProps<Props>();

defineEmits<{
  click: [];
}>();
</script>
